var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-line',_vm._b({attrs:{"items":_vm.items}},'button-line',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }